(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'tooltipifyContent', [ '$compile', '$interpolate', 'LoggerFactory', 'Utils', TooltipifyContentDirective ]);


    /**
     * Scans nested content looking for a text in format of `[tooltipId]`.
     * If existing tooltip ID is found, it wraps the term into inline tooltip
     * with detailed explanation. If not, it simply removes the brackets and
     * logs an error into the console.
     *
     * @param {ng.ICompileService} $compile
     * @param {ng.IInterpolateService} $interpolate
     * @param {LoggerFactory} LoggerFactory
     * @param {Utils} Utils
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function TooltipifyContentDirective(
        $compile,
        $interpolate,
        LoggerFactory,
        Utils
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'TooltipifyContentDirective', false );


        /** @const */
        var TOOLTIP_REGEX = /\[([^{\[\]}]+)\]/g; // Matches format: [tooltipId]

        /** @type {ng.IDirective} */
        var directiveConfig = {
            restrict:   'AE',
            transclude: true,
            scope:      {},
            link:       link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ng.IElement} element
         * @param {ng.IAttributes} attrs
         * @param {ng.IController} ctrl
         * @param {ng.ITranscludeFunction} transclude
         */
        function link(
            $scope,
            element,
            attrs,
            ctrl,
            transclude
        ){





            /* ===== PRIVATE MEMBERS ======================================== */


            /** @type {DOMElement} */
            var tooltipifiedBlock;





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                setDefaults();
                compile();
            })();


            /** @destructor */
            (function destroy(){
                element.on( '$destroy', function () {
                    if ( tooltipifiedBlock ){
                        tooltipifiedBlock.remove();

                        // Reset to defaults
                        setDefaults();
                    }
                });
            })();





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function compile() {
                transclude( function( clonedElement, $outerScope ){
                    var elementsHTML = '',
                    interpolatedHTML,
                    enhancedHTML,
                    i;

                    // Assemble element's HTML by joining outer HTML's of its children.

                    for ( i = 0; i < clonedElement.length; i++ ){
                        if ( clonedElement[ i ].nodeType === 3 ) // If it's a TEXT node
                        {
                            elementsHTML += clonedElement[ i ].nodeValue;
                        } else {
                            elementsHTML += clonedElement[ i ].outerHTML ? clonedElement[ i ].outerHTML : '';
                        }
                    }

                    // 1. Manually interpolate all expressions against scope they are in.
                    interpolatedHTML = $interpolate( elementsHTML )( $outerScope );

                    // If the first or last node is a text node, wrap it with <span></span> to avoid problems with $compile()
                    if ( clonedElement[ 0 ].nodeType === 3 || clonedElement[ clonedElement.length - 1 ].nodeType === 3 ) {
                        interpolatedHTML = '<span>' + interpolatedHTML + '</span>';
                    }

                    // 2. Find all tooltip markers and if there are any, wrap them into tooltip markup.
                    enhancedHTML = interpolatedHTML.replace( TOOLTIP_REGEX, wrapTooltipWithHTML );


                    // Render using compilation (~ creation of DOM elements)
                    tooltipifiedBlock = $compile( enhancedHTML )( $outerScope );

                    // 3. Attach to the current DOM node
                    element.append( tooltipifiedBlock );
                });
            }


            function wrapTooltipWithHTML( _, tooltipKey ){
                var tooltipDescription = Utils.getTooltipById( tooltipKey.toLowerCase());

                if ( tooltipDescription ){
                    return '<a ng-href="{{:: \'javascript:;\' | safeUrl }}" class="tooltip-switch tooltip-inline" tooltipify title="' + tooltipDescription + '">' + tooltipKey + '</a>'
                } else {
                    logger.error( "Tooltip ID `" + tooltipKey + "` has not been found in the list of available tooltips and so it won't be tooltipified." );
                }

                return tooltipKey;
            }


            function setDefaults(){
                tooltipifiedBlock   = null;
            }


        }



    }
})();
